<template>
  <div class="pogs-list__item"
       @click.stop="openCase()">
    <div class="patient-img">
      <div class="smd-profile-image m">
        <template v-if="!patientcase.avatar">
          {{initials}}
        </template>
      </div>
    </div>

    <div class="patient-data">
      <div class="patient-data__details">
        <div class="patient-data__name">
          <h3>{{patientcase.caseNum}}</h3>
          <span v-if="patientcase.isArchived" class="archive-pill">Archived</span>
        </div>
        <div class="patient-data__meta">
          <p><label>AGE:</label> {{patientcase.age }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import uiHelper from '../../../mixins/uihelper'
  import Routes from '../../../router/route-constants'
  import Store from '../../../../src/store/store'
  import {MUTATE_SHOW_NAV} from "../../../store/modules/shared";

  export default {
    name: "pogs-list__item--cases",
    props: {
      patientcase: {
        patientid: String,
        caseNum: String,
        admissionDate: String,
        age: Number,
        isGyne: Boolean,
        isPregnancy: Boolean,
        hasOpenCase: false,
        isArchived: Boolean
      }
    },
    mixins: [uiHelper],
    data(){
      return{
        activeID: null
      }
    },
    computed:{
      initials(){
        return this.patientcase.caseNum ?
          this.patientcase.caseNum.substring(0,2).toUpperCase() : ' ';
      }
    },
    methods: {
      openCase() {
        const params = {
          patientid: this.patientcase.patientid,
          caseid: this.patientcase._id
        };

        this.toggleOverlay();
        this.$router.push({
          name: Routes.ROUTE_EDIT_PATIENT_CASE,
          params: params
        })
      }
    }

  }
</script>
<style lang="scss" scoped>
.archive-pill {
  display: inline-block;
  background-color: #ff6a6a;
  color: white;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  margin-left: 0.5rem;
  vertical-align: middle;
}
.patient-data__name {
  display: flex;
  align-items: center;

  h3 {
    margin: 0;
  }
}
</style>